import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'data-upload',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./DataUpload').default
      callback(null, component)
    }, 'DataUpload')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/DataUpload/index.js